import { render } from "./Regisgo.vue?vue&type=template&id=2f8deca1"
import script from "./Regisgo.vue?vue&type=script&lang=js"
export * from "./Regisgo.vue?vue&type=script&lang=js"

import "./Regisgo.vue?vue&type=style&index=0&id=2f8deca1&lang=css"

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__